module.exports = __webpack_public_path__ + "607f6f1edbe06d4e68e26b99da912f30.jpg";